import ListingCategory from '@domain-group/fe-allhomes-library/lib/enums/listing-category';
export var GAActions = {
  EMAIL_AGENT: 'Email Agent Button',
  VIEW_IMAGES: 'View Images',
  CLICK_TO_REVEAL_PREFIX: 'Click to Reveal - ',
  INSPECTION_PLANNER_PREFIX: 'Inspection Planner - ',
  MAP_INTERACTION: 'Map Interaction',
  ADD_TO_CALENDAR_PREFIX: 'Add to Calendar - ',
  INSPECTION_PLANNER: 'InspectionPlanner',
  SUBURB_INFORMATION: 'Suburb Information',
  PROPERTY_HISTORY: 'Property History',
  AUCTION: 'Auction',
  INSPECTION: 'Inspection',
  PROPERTY_WALKTHROUGH: 'Property Walkthrough',
  DEVELOPMENT_WEBSITE_LINK: 'Development Website Link',
  EARLY_ACCESS: 'Early Access',
  FIND_AN_AGENT: 'Find an Agent',
  ONLINE_AUCTION: 'Online auction',
  EDITORIAL_SHOWCASE: 'Editorial Showcase',
  NEARBY_SALES_ONMARKET: 'Nearby Sales - Onmarket',
  LISTING_ENQUIRY_FORM: 'Enquiry Form'
};
export var GALabels = {
  AGENT_INFO_BOX: 'Agent Info Box',
  FOOTER_CTA: 'Footer CTA',
  VIEW_FLOOR_PLAN: 'View Floor Plan Icon',
  VIEW_FLOOR_PLAN_SHORTCUT: 'View Floor Plan Icon - Shortcut',
  VIEW_VIDEO: 'View Video Icon',
  VIEW_VIDEO_SHORTCUT: 'View Video Icon - Shortcut',
  VIEW_3D_TOUR: 'View 3D Tour Icon',
  VIEW_3D_TOUR_SHORTCUT: 'View 3D Tour Icon - Shortcut',
  OPEN_GALLERY: 'Open Gallery',
  CAROUSEL_RIGHT: 'Carousel Right - Gallery',
  CAROUSEL_LEFT: 'Carousel Left - Gallery',
  PREVIEW_RIGHT: 'Carousel Right - Header Image',
  PREVIEW_LEFT: 'Carousel Left - Header Image',
  PROMO_BOX: 'Listing Details - View planner',
  REMOVE_FROM_PLANNER: 'Listing Details - Remove inspection',
  CONTACT_AGENT: 'Contact agent',
  ADD_AUCTION_TO_CALENDAR: 'Add to calendar',
  ADD_TO_CALENDAR: 'Listing Details - add to calendar',
  ADD_TO_CALENDAR_MODAL: 'Confirmation Modal - add to calendar',
  CASUAL_SIGN_UP: 'Casual limit popup - Sign Up',
  CASUAL_LOG_IN: 'Casual limit popup - Log In',
  VIEW_SUBURB_INFO: 'View suburb information',
  VIEW_MORE_SUBURB_INFO: 'View suburb information on Research page',
  VIEW_SUBURB_SUMMARY: 'View summary',
  VIEW_MEDIAN_SALES: 'View median sales',
  VIEW_UV_INFO: 'View unimproved value',
  PROPERTY_HISTORY_LEFT_SWIPE: 'Swipe card to left',
  PROPERTY_HISTORY_RIGHT_SWIPE: 'Swipe card to right',
  PROPERTY_HISTORY_LEFT_TAP: 'Tap left chevron',
  PROPERTY_HISTORY_RIGHT_TAP: 'Tap right chevron',
  PROPERTY_HISTORY_EXPAND: 'Expand card',
  PROPERTY_HISTORY_COLLAPSE: 'Collapse card',
  PROPERTY_HISTORY_PHOTO_GALLERY: 'Expand photo gallery',
  ONLINE_AUCTION: 'View online auction',
  AUCTION_PROMO_CTA: 'Register for online auction',
  ONLINE_AUCTION_INFO: 'How online auctions work',
  INSPECT_FROM_HOME_CTA: 'Inspect From Home CTA',
  VIEW_WALKTHROUGH_VIDEO: 'View Video',
  VIEW_WALKTHROUGH_3D: 'View 3D',
  DEVELOPMENT_WEBSITE_LINK_CHILD: 'Child - Visit development website',
  DEVELOPMENT_WEBSITE_LINK_PARENT: 'Parent - Visit development website',
  CONTINUE_YOUR_SEARCH: 'Continue your search',
  VIEW_PROPERTY_ALERTS: 'View property alerts',
  INTERACT_WITH_MAP: 'Interact with map',
  EARLY_ACCESS_INFO_PAGE: 'View Early Access Info Page',
  EARLY_ACCESS_PAGE_LOAD: 'Load listing page',
  REQUEST_INSPECTION: 'Request Inspection',
  AGENCY_BRANDING: 'Agency Branding - Mobile',
  VIEW_PAST_SALES: 'View past sales and photos',
  FIND_AN_AGENT_OFF_MARKET_CTA: 'Find an Agent on Offmarket page - Click',
  ONLINE_AUCTION_PRIMARY_CTA: 'Primary CTA',
  OPEN_SIGN_IN: 'Open Sign In Modal',
  VIEWED_CAMPAIGN: 'Viewed Campaign',
  CLICKED_LEARN_MORE: 'Clicked Learn More',
  ENTER_FULL_SCREEN: 'Enter Full Screen',
  EXIT_FULL_SCREEN: 'Exit Full Screen'
};
export var ListingTypeLabel = {
  [ListingCategory.BUY]: 'Buy',
  [ListingCategory.RENT]: 'Rent',
  [ListingCategory.DEVELOPMENTS]: 'New Homes',
  [ListingCategory.SHARE]: 'Share'
};
export var ListingUseType = {
  RESIDENTIAL: 'Residential',
  COMMERCIAL: 'Commercial',
  BUSINESS: 'Business'
};
export var MixpanelLabels = {
  AGENT_INFO_BOX: 'Agent Info Box',
  FLOATING_CTA: 'Floating CTA',
  ENQUIRY_FORM: 'Enquiry Form',
  INSPECTIONS_SECTION: 'Inspections Section',
  INSPECTION: 'Inspection',
  AUCTION: 'Auction',
  LISTING_MAP_CARD: 'Listing - Map Card',
  VIEW_SUBURB_PROFILE: 'View Suburb Profile',
  VIEW_SUBURB_PROFILE_CLICK: 'View Suburb Profile - Suburb Insights',
  VIEW_SUBURB_PROFILE_STICKY: 'View Suburb Profile - Sticky Sidebox'
};